// extracted by mini-css-extract-plugin
export var typingIndicator = "_rj-0";